// Redux actions
import * as REDUX_ACTION from "../../../../../../../v1/services/redux/actions";

export const handleMark = (record, action, user, dispatch, messageApi) => {
  let updatedStatus;
  if (
    action === "disbursed" &&
    (record.status === 1 ||
      record.status === 2 ||
      record.status === 3 ||
      record.status === 0)
  ) {
    updatedStatus = 4;
  } else if (
    action === "cancelled" &&
    (record.status === 1 ||
      record.status === 2 ||
      record.status === 3 ||
      record.status === 4)
  ) {
    updatedStatus = 0;
  } else if (
    action === "ready_for_processing" &&
    (record.status === 2 ||
      record.status === 3 ||
      record.status === 4 ||
      record.status === 0)
  ) {
    updatedStatus = 1;
  } else {
    console.error("Invalid action or status");
  }

  if (updatedStatus !== undefined) {
    const updatedRecord = {
      prid: record.prid,
      updatedBy: user?.memid,
      status: updatedStatus,
    };

    delete updatedRecord.key;
    delete updatedRecord.bankName;
    delete updatedRecord.bankAcc;
    delete updatedRecord.employee_name;
    delete updatedRecord.employe_memid;
    delete updatedRecord.employee_contact;
    delete updatedRecord.employee_ic;
    delete updatedRecord.employee_refid;
    if (user?.uroleid === "A") {
      delete updatedRecord.loyalty;
      delete updatedRecord.rhbName;
    } else {
      delete updatedRecord.tiers;
    }

    messageApi.open({
      type: "loading",
      content: "Updating Status...",
      duration: 0,
    });

    dispatch(
      REDUX_ACTION.v1_payroll.update_payroll_request(updatedRecord, () => {
        messageApi.destroy();
      })
    );
  } else {
    console.error("Invalid action or status");
  }
};

export const sumByKey = (data, key) =>
  data.reduce((sum, record) => {
    const value = record[key];
    return sum + parseFloat(value || 0);
  }, 0);